import React, { useEffect, useState, useRef } from "react";
import { Chip, Grid, Typography, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import {
  EditButton,
  Labeled,
  Show,
  Tab,
  TabbedShowLayout,
  TextField,
  TopToolbar,
  useNotify,
  useShowController,
} from "react-admin";

import { isAdmin, logError } from "../../../utils/appUtils";
import { getAisleFullName } from "../../../utils/locationUtils";

import { NotesTabShow } from "../../../components/common/NotesTab";

import { ServicesPeak } from "../services/ServicesPeak";
import { ContactInfo } from "./ContactInfo";
import { LoadTypesPanel } from "./LoadTypesPanel";
import YardSettingsTab from "./YardSettingsTab";

const _ = require("lodash");

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    display: "flex",
  },
  selectedAccess: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
    marginBottom: theme.spacing(2),
  },
}));

const MyYardShowActions = ({ basePath, data }) => (
  <TopToolbar>
    <EditButton basePath={basePath} record={data} />
  </TopToolbar>
);

export const MyYardShow = (props) => {
  const classes = useStyles();
  const notify = useNotify();
  const { record } = useShowController(props);
  const [commodities, setCommodities] = useState([]);
  const xsDown = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const isComponentMounted = useRef(true);

  useEffect(() => {
    if (isComponentMounted) getData();
    return () => (isComponentMounted.current = false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record]);

  const getData = async () => {
    try {
      debugger;
      if (!record?.id) return;

      const data = _.orderBy(
        record.yardCommodities.items,
        ["sortKey"],
        ["asc"]
      );
      setCommodities([...data]);
    } catch (err) {
      logError("reloadYard:ReloadYardShow:getData", err, notify);
    }
  };

  return (
    <Show {...props} actions={<MyYardShowActions />} title={record?.name}>
      <TabbedShowLayout>
        <Tab label={"Contact Info"}>
          <ContactInfo
            {...props}
            classes={classes}
            record={record}
            disabled={true}
          />
        </Tab>
        {!xsDown && (
          <Tab path="loadTypes" label="Load Types">
            <LoadTypesPanel commodities={commodities} disabled={true} />
          </Tab>
        )}
        {!xsDown && (
          <Tab path="services" label="Service Rates">
            <ServicesPeak {...props} record={record} />
          </Tab>
        )}
        <Tab path="layout" label="Layout">
          <div className={classes.root}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                {record?.areas?.items?.map((area) => (
                  <div key={area.id}>
                    <Typography variant="subtitle2">{area.name}</Typography>
                    <div className={classes.selectedAccess}>
                      {record?.aisles
                        ? record.aisles.items
                            .filter((itm) => itm.areaId === area.id)
                            .map((aisle, idx) => (
                              <Chip
                                size="medium"
                                variant="outlined"
                                style={{
                                  fontWeight: "bold",
                                  color: "#ffffff",
                                  backgroundColor: aisle.zone?.color
                                    ? aisle.zone.color
                                    : "#90A4AE",
                                }}
                                key={aisle.id}
                                label={getAisleFullName(aisle)}
                              />
                            ))
                        : null}
                    </div>
                  </div>
                ))}
              </Grid>
            </Grid>
          </div>
        </Tab>
        {!xsDown && (
          <Tab path="settings" label="Settings">
            <YardSettingsTab {...props} disabled={true} record={record} />
          </Tab>
        )}
        {isAdmin() && (
          <Tab path="subscription" label="Subscription">
            <Grid container>
              <Grid item xs={12} md={6}>
                <Labeled label="Customer Id">
                  <TextField
                    source={"subscription.customerId"}
                    record={record}
                  />
                </Labeled>
              </Grid>
              <Grid item xs={12} md={6}>
                <Labeled label="Price Id">
                  <TextField source="subscription.priceId" record={record} />
                </Labeled>
              </Grid>
              <Grid item xs={12} md={6}>
                <Labeled label="Plan">
                  <TextField source="subscription.name" record={record} />
                </Labeled>
              </Grid>
              <Grid item xs={12} md={6}>
                <Labeled label="Subscription Id">
                  <TextField
                    source="subscription.subscriptionId"
                    record={record}
                  />
                </Labeled>
              </Grid>
              <Grid item xs={12} md={6}>
                <Labeled label="Status">
                  <TextField source="subscription.status" record={record} />
                </Labeled>
              </Grid>
            </Grid>
          </Tab>
        )}
        {isAdmin() && (
          <Tab label="Notes">
            <NotesTabShow />
          </Tab>
        )}
      </TabbedShowLayout>
    </Show>
  );
};
